export default "__VITE_ASSET__DInG26GQ__"